export const WEEKDAYS = [
  {
    position: 0,
    long: 'Monday',
    short: 'Mon',
    abbrev: 'M',
  },
  {
    position: 1,
    long: 'Tuesday',
    short: 'Tue',
    abbrev: 'T',
  },
  {
    position: 2,
    long: 'Wednesday',
    short: 'Wed',
    abbrev: 'W',
  },
  {
    position: 3,
    long: 'Thursday',
    short: 'Thu',
    abbrev: 'Th',
  },
  {
    position: 4,
    long: 'Friday',
    short: 'Fri',
    abbrev: 'F',
  },
  {
    position: 5,
    long: 'Saturday',
    short: 'Sat',
    abbrev: 'S',
  },
  {
    position: 6,
    long: 'Sunday',
    short: 'Sun',
    abbrev: 'Su',
  },
];
